import styles from "./styles.module.scss"

import { GoToAuth, HeaderLogo, HeaderMenu, HeaderRoot } from "components/Header"
import { isAuthPage, isPsyAccountPage } from "app/AppRouter/utils"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

export function Header() {
    const [{ isVerified }] = useClientContext()

    return (
        <HeaderRoot>
            <div className={styles.left} />
            <HeaderLogo>alter</HeaderLogo>
            {!isVerified && !isAuthPage() && !isPsyAccountPage() && <GoToAuth />}
            {isVerified && <HeaderMenu />}
        </HeaderRoot>
    )
}
